import React from "react";
import { useIntl } from "react-intl";
import { buttonList } from "../utils/constants";
import { FormHelperText, Box } from "@mui/material";
import SunEditor from "suneditor-react";

export default function RichTextEditor({ error, helperText, ...props }) {
  const intl = useIntl();

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          textAlign: "left",
          "& .sun-editor": {
            border: `1px solid ${error ? "hsl(0, 72%, 51%)" : "hsl(160, 10%, 90%)"}`,
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
            fontFamily: "Segoe UI Regular, system-ui, sans-serif",
            transition: "border-color 0.2s, box-shadow 0.2s",
          },
          "& .sun-editor:focus-within": {
            borderColor: "hsl(153, 68%, 25%)",
            boxShadow: "0 0 0 3px hsla(153, 68%, 25%, 0.3)",
          },
          "& .sun-editor .se-toolbar": {
            backgroundColor: "hsl(178, 30%, 97%)",
            borderBottom: "1px solid hsl(160, 10%, 90%)",
            outline: "none",
          },
          "& .sun-editor .se-resizing-bar": {
            borderTop: "1px solid hsl(160, 10%, 90%)",
            backgroundColor: "hsl(178, 30%, 97%)",
          },
        }}
      >
        <SunEditor
          setDefaultStyle="font-family: 'Segoe UI Regular, sans-serif';"
          setOptions={{
            buttonList,
            pasteTagsBlacklist: "span",
            attributesBlacklist: {
              all: "style",
            },
            placeholder:
              props.placeholder ||
              intl?.formatMessage({ id: "enter_text_editor" }),
          }}
          height={props.height || "200px"}
          width="100%"
          {...props}
        />
      </Box>
      {error && <FormHelperText error> {helperText} </FormHelperText>}
    </Box>
  );
}
